"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const PageColumns = styled_components_1.default.div `
  width: 100%;
  [data-component="card"] {
    margin-bottom: ${({ theme }) => theme.spacings.xs};
  }
`;
const Page = styled_components_1.default.div.attrs((props) => ({
    columns: props.columns || 1
})) `
  display: block;
  max-width: 50%;
  min-width: 645px;
  margin: 0 auto;

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    min-width: unset;
    max-width: 100%;
  }

  &[data-grid="true"] {
    max-width: 1600px;
    ${PageColumns} {
      display: grid;
      grid-template-columns: repeat(${(props) => props.columns}, 1fr);
      grid-column-gap: ${({ theme }) => theme.spacings.m};
      @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
        grid-template-columns: 1fr;
        grid-gap: 0;
      }
    }
  }
`;
const Breadcrumb = styled_components_1.default.div `
  padding: ${({ theme }) => theme.spacings.xl} 0;
  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: ${({ theme }) => theme.spacings.m};
  }
`;
const Banner = styled_components_1.default.div `
  margin-bottom: ${({ theme }) => theme.spacings.m};

  & > div:not(:last-of-type) {
    margin-bottom: ${({ theme }) => theme.spacings.xs};
  }

  &:empty {
    margin-bottom: 0;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: 0 ${({ theme }) => theme.spacings.m};
  }
`;
const PageFC = ({ breadcrumb, banner, columns, children, className }) => {
    return ((0, jsx_runtime_1.jsxs)(Page, { columns: columns ? columns.length : 1, "data-columns": columns ? columns.length : 1, "data-grid": columns ? true : false, className: className, children: [breadcrumb && (0, jsx_runtime_1.jsx)(Breadcrumb, { children: breadcrumb }, void 0), banner && (0, jsx_runtime_1.jsx)(Banner, { children: banner }, void 0), (0, jsx_runtime_1.jsxs)(PageColumns, { children: [columns &&
                        columns.map((column, idx) => ((0, jsx_runtime_1.jsx)("div", { children: column }, `column-${idx}`))), children] }, void 0)] }, void 0));
};
exports.default = PageFC;
//# sourceMappingURL=Page.js.map